module.exports = __webpack_public_path__ + "img/homeIc1.6cb8ec4c.png";